
export class SearchFilters {
  public customer: number[] = [];
  public jobsite: number[] = [];
  public equipment: number[] = [];
  public make: number[] = [];
  public model: number[] = [];
  public implement: number[] = [];
  public evalA: boolean = true;
  public evalB: boolean = true;
  public evalC: boolean = true;
  public evalX: boolean = true;
  public onEq: boolean = true;
  public NoImps: boolean = false;
}
export class ImplementSelectItem {
  Id: number;
  Name: string;
  CustomerId: number;
}

export class RepairerSelectItem {
  Id: number;
  Name: string;
}

export class FamilyListItem {
  Id: number;
  Name: string;
}

export class ImplementItem {
  Id: number;
  Name: string;
  ImplementId:number
}

export class ImplementSelectionFilter {
  Implement: number[]
}

export class ObservationPointId {
  ObsId: number
}

export class FECRInspectionHistoryVM {
  FormUploadId: number;
  FormId: number;
  FormName: string;
  StartDate: string;
  Status: string;
  FECRInspectionType: string
}

export class FECRDashboardSearch {
  public customers: number[];
  public jobsites: number[];
  public implementTypes: number[];
  public repairers: number[];
  public family: number[];
  public models: number[];
  public implements: number[];
  public status: number[];
}

export class FECRDashboradImplementVM {
  public ImplementId: number;
  public ImplementName: string;
  public ImpType: string;
  public Repairer: string;
  public workshop: string;
  public Model: string;
  public StartDate: string;
  public CompletePercent: number;
  public totalHours: number;
  public totalCost: number;
  public SOWApprovalRequired: boolean;
  public Status: string;
  public Required:boolean;
  public Response:boolean;
}

export class FECRAdditionalObsVM{
  public Id:number;
  public Title:string;
  public Active:boolean;
  public InspectionTypeId:number;
  public InspectionTypeName:string;
  public CreateduserName:string;
  public CreatedDate:Date;
  public ImplementTypeId:number;
  public ObsId :number;

}

export class FECRInspectionAdditionalObsVM{
  public InspectionId:number;
  public InspectionTypeId:number;
  public CreatedDate:Date;
  public ImplementTypeId:number;
  public ImplementId:number;
  public AdditionalObsPoints: FECRPrePostAdditionalObsVM[];
}

export class FECRPrePostAdditionalObsVM{
  public Id:number;
  public InspectionId:number;
  public RefId:number;
  public Title:string;
  public Comment:string;
  public Images:ImageList[];
}

export class ImageList {
 public Id:number;
 public Image:string;
}